import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import PageMeta from "./components/PageMeta";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Lessons from "./pages/Lessons";
import Practice from "./pages/Practice";
import TestPage from "./pages/TestPage";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Utilities, { UTILITY_TOOLS, UtilityToolPage } from "./pages/Utilities";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import NotFound, { LegacyRedirect } from "./pages/NotFound";
import { Toaster } from "sonner";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <PageMeta />
                <div className="App min-h-screen flex flex-col">
                    <Navbar />
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/lessons" element={<Lessons />} />
                            <Route path="/practice" element={<Practice />} />
                            <Route path="/test" element={<TestPage />} />
                            <Route path="/leaderboard" element={<Leaderboard />} />
                            <Route path="/utilities" element={<Utilities />} />
                            {Object.keys(UTILITY_TOOLS).map((slug) => (
                                <Route key={slug} path={`/${slug}`} element={<UtilityToolPage slug={slug} />} />
                            ))}
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/privacy" element={<Privacy />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route
                                path="/master-traditional-nepali-keyboard"
                                element={<LegacyRedirect to="https://lipityping.com" />}
                            />
                            <Route path="*" element={<NotFound />} />
                            <Route
                                path="/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <Dashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/profile"
                                element={
                                    <ProtectedRoute>
                                        <Profile />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </main>
                    <Footer />
                    <Toaster theme="dark" position="top-right" />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}
